<template>
  <div class="tab-text">
    <div class="vx-row mb-6 mt-2">
      <div class="vx-col sm: w-full md:w-1/2 mt-4 set_limit">
        <label class="limit_label">{{ $t("labels.show") }}</label>
        <v-select
          v-model="limit"
          :options="limitarr"
          :reduce="(limitarr) => limitarr.value"
          :clearable="false"
          label="text"
          class="px-1"
        />
        <label class="limit_label">{{ $t("labels.admins") }}</label>
      </div>
      <div class="vx-col sm: w-full md:w-1/2">
        <div class="mt-4 admin-listing">
          <div class="filter">
            <vs-button
              color="maroon"
              type="filled"
              icon-pack="feather"
              icon="icon-filter"
              @click="showfilter = !showfilter"
              class="btn-color sm: px-6 md:px-10"
              >{{ $t("labels.filter") }}
            </vs-button>
          </div>
          <div class="imp-exp">
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-download"
              @click="showImport = !showImport"
              class="btn-color sm: ml-0 md:ml-4 sm: px-6 md:px-10"
              >{{ $t("labels.import") }}</vs-button
            >
            <vs-button
              color="dark"
              type="filled"
              icon-pack="feather"
              icon="icon-upload"
              @click.prevent="exportCsv()"
              class="btn-color ml-4 sm: px-6 md:px-10"
              >{{ $t("labels.export") }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <vx-card class="filter-card filter_card" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.block_unblock") }}</label>
          <v-select
            v-model="block"
            :options="filterBlock"
            :reduce="(filterBlock) => filterBlock.value"
            label="text"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="!this.search && !this.block"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search && !this.block"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="question-import" v-show="showImport == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/4 flex justify-center">
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-download"
            :title="$t('labels.download_sample_csv')"
            @click.prevent="downloadSampleCsv()"
            class="btn-color"
            >{{ $t("labels.sample_import_csv") }}</vs-button
          >
        </div>
        <div class="vx-col sm: w-full md:w-1/3 md:pl-12">
          <input
            type="file"
            id="file"
            name="importFile"
            class="vs-inputx vs-input--input normal hasValue"
            accept=".csv"
            ref="file"
            v-on:change="handleFileUpload()"
          />
        </div>
        <div class="vx-col sm: w-full md:w-2/5 flex justify-center">
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.clear')"
            @click="clearImport()"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            :title="$t('labels.import_csv')"
            @click.prevent="submitFile()"
            class="sm:ml-0 px-10 btn-color float-left"
            >{{ $t("labels.import") }}
          </vs-button>
        </div>
      </div>
    </vx-card>
    <vs-table :data="admins" class="permission">
      <template slot="thead">
        <vs-th class="col-md-5">{{ $t("labels.name") }}</vs-th>
        <vs-th class="col-md-5">{{ $t("labels.email") }}</vs-th>
        <vs-th class="col-md-3">{{ $t("labels.role") }}</vs-th>
        <vs-th class="pl-8 col-md-3">{{ $t("labels.action") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          v-bind:class="[tr.is_blocked == 1 ? 'user-table' : '']"
        >
          <vs-td :data="tr.username">
            <router-link
              class="view-link"
              :to="{ name: 'ViewUser', params: { id: tr.id } }"
              v-if="checkPermission('user', 'view')"
              >{{ tr.name }}</router-link
            >
          </vs-td>
          <vs-td :data="tr.email">{{ tr.email }}</vs-td>
          <vs-td :data="tr.role.name">{{ tr.role.name }}</vs-td>
          <vs-td width="200">
            <div class="flex">
              <router-link
                class="view-link"
                :to="{ name: 'ViewUser', params: { id: tr.id } }"
                v-if="checkPermission('user', 'view')"
              >
                <vs-button
                  color="dark"
                  type="flat"
                  :title="$t('labels.view')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="btn-icon"
                ></vs-button>
              </router-link>
              <router-link
                class="view-link"
                :to="{ name: 'EditUser', params: { id: tr.id } }"
                v-if="checkPermission('user', 'modify')"
              >
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="hover-color btn-icon"
                ></vs-button>
              </router-link>

              <vs-button
                @click="deleteConfirm(indextr)"
                type="flat"
                :title="$t('labels.delete')"
                size="large"
                icon-pack="feather"
                icon="icon-trash-2"
                color="danger"
                class="hover-color btn-icon"
                v-if="checkPermission('user', 'delete')"
              ></vs-button>
              <vs-button
                @click="blockConfirm(indextr)"
                type="flat"
                :title="
                  !tr.is_blocked ? $t('labels.block') : $t('labels.unblock')
                "
                size="large"
                icon-pack="feather"
                :icon="tr.is_blocked ? 'icon-unlock' : 'icon-lock'"
                :color="tr.is_blocked ? 'primary' : 'warning'"
                class="block-btn hover-color btn-icon"
              ></vs-button>
              <vs-button
                type="flat"
                :title="$t('labels.reset_pass_button')"
                size="small"
                class="key-icon hover-color btn-icon"
                color="success"
                @click="resetPassConfirm(indextr)"
              >
                <key-icon
                  size="2x"
                  class="custom-class"
                  color="danger"
                ></key-icon>
              </vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="mt-6">
      <vs-pagination
        color="dark"
        :total="$store.state.userData.adminCount"
        v-model="currentx"
        class="mb-1"
      >
      </vs-pagination>
    </div>
  </div>
</template>

<script>
import { KeyIcon } from "vue-feather-icons";
import { EventBus } from "@/mixins/mixin.js";

export default {
  components: {
    KeyIcon,
  },
  data() {
    return {
      currentx: this.$store.state.userData.adminCurrent,
      // limit: parseInt(process.env.VUE_APP_PER_PAGE),
      limit: this.$store.state.limit,
      showfilter: false,
      showImport: false,
      sample_csv_url: this.$store.state.userData.adminSampleCsv,
      file: null,
      search: this.$store.state.userData.adminSearch,
      block: this.$store.state.userData.adminBlock,
      filterBlock: [
        { text: this.$t("labels.block"), value: true },
        { text: this.$t("labels.unblock"), value: false },
      ],
    };
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    if (
      this.$store.state.userData.adminSearch ||
      this.$store.state.userData.adminBlock
    ) {
      this.showfilter = true;
    }
    this.$store.commit("UPDATE_TAB", 0);
  },
  watch: {
    currentx(val) {
      this.$store.commit("updateAdminCurrent", val, { module: "userData" });
      EventBus.$emit("pageChanged", "A");
    },
    limit(val) {
      localStorage.setItem("limit", val);
      this.$store.commit("updateAdminLimit", val, { module: "userData" });
      this.currentx = 1;
      EventBus.$emit("limitChanged", "A");
    },
    showImport(val) {
      if (val) {
        this.showfilter = false;
      }
    },
    showfilter(val) {
      if (val) {
        this.showImport = false;
      }
    },
  },
  computed: {
    admins() {
      return this.$store.state.userData.admins;
    },
  },
  methods: {
    deleteConfirm(indextr) {
      EventBus.$emit("deleteConfirm", indextr);
    },
    blockConfirm(indextr) {
      EventBus.$emit("blockConfirm", indextr);
    },
    resetPassConfirm(indextr) {
      EventBus.$emit("resetPassConfirm", indextr);
    },
    exportCsv() {
      EventBus.$emit("export", "A");
    },
    async submitFile() {
      let data = new FormData();
      data.set("file", this.importFile);
      let response = await this.getHTTPPostResponse(
        "/users/import",
        data,
        "",
        true
      );
      if (response) {
        let data = response.data;
        this.showImport = false;
        document.getElementById("file").value = "";
        EventBus.$emit("import", "A");
      }
    },
    handleFileUpload() {
      this.importFile = this.$refs.file.files[0];
    },
    filter() {
      this.$store.commit("updateAdminSearch", this.search, {
        module: "userData",
      });
      this.$store.commit("updateAdminBlock", this.block, {
        module: "userData",
      });
      EventBus.$emit("filter", "A");
    },
    clearFilter() {
      this.search = null;
      this.block = null;
      this.$store.commit("updateAdminSearch", null, {
        module: "userData",
      });
      this.$store.commit("updateAdminBlock", null, {
        module: "userData",
      });
      EventBus.$emit("filter", "A");
    },
    clearImport() {
      document.getElementById("file").value = "";
    },
    downloadSampleCsv() {
      window.open(this.$store.state.userData.adminSampleCsv, "_self");
    },
  },
};
</script>
<style scoped>
.btn-icon {
  width: 30px !important;
  height: 30px !important;
  padding: 16px !important;
}
</style>
